"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeHttpRequest = exports.RequestMethod = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
var RequestMethod;
(function (RequestMethod) {
    RequestMethod["GET"] = "GET";
    RequestMethod["POST"] = "POST";
})(RequestMethod = exports.RequestMethod || (exports.RequestMethod = {}));
const getFetchOptions = (method) => {
    return {
        method,
        headers: {
            "Content-Type": "application/json;charset=utf-8",
        },
    };
};
function makeHttpRequest(params) {
    return new Promise(async (resolve, reject) => {
        const fetchOptions = getFetchOptions(params.method);
        if (params.method === RequestMethod.POST) {
            fetchOptions.body = JSON.stringify(params.body);
        }
        const queryParamsArray = [];
        let queryParamString = "";
        if (params.queryParams) {
            for (const [key, value] of params.queryParams) {
                queryParamsArray.push(key + "=" + value);
            }
            queryParamString = queryParamsArray.join("&");
        }
        (0, cross_fetch_1.default)(`${params.baseURL}${params.path}?${queryParamString}`, fetchOptions)
            .then((response) => {
            if (response.headers.get("content-type").includes("application/json")) {
                return response.json();
            }
            else {
                return response.text();
            }
        })
            .then((response) => {
            resolve(response);
        })
            .catch((error) => {
            reject(error);
        });
    });
}
exports.makeHttpRequest = makeHttpRequest;
